import "./style.css";

import { useProgress } from "../../../../../hooks/progress";
import { IWatch } from "../../../../../interfaces/watch";
import Arrazo from "../../../../shared/Arrazo";
import ControlsOverlay from "./ControlsOverlay";
import Loading from "./Loading";
import Player from "./VideoContainer";
import { useIsMobile } from "../../../../../hooks/useIsMobile";
import { useCustomPlayerContext } from "../../../../../contexts/CustomPlayerContext";

interface IVideoProps {
  watchInfo: IWatch;
}

const Video: React.FC<IVideoProps> = ({ watchInfo }) => {
  const { customPlayerPreferences } = useCustomPlayerContext();
  const isMobile = useIsMobile();
  useProgress(watchInfo.previewMode);

  const playPauseButtonIsVisibleToUser = customPlayerPreferences.allowPlayPause;
  const willAutoplayBeAvailable = !playPauseButtonIsVisibleToUser;

  return (
    <section id="safevideo-player" className="player">
      <Player
        loop={watchInfo.previewMode || customPlayerPreferences.allowActivateLoop}
        autoplay={willAutoplayBeAvailable}
        playlistURL={watchInfo?.playlist ?? ""}
        seekTime={watchInfo?.seekTime ?? 0}
        thumbnail={watchInfo?.thumbnail ?? ""}
        isMobile={isMobile}
      />


      {!isMobile && (
        <ControlsOverlay isPreviewMode={watchInfo?.previewMode ?? false} />
      )}
      <Loading />
      <Arrazo />
    </section>
  );
};

export default Video;
